import React, { forwardRef } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { List, ListItem, Button, Box } from '@mui/material';

const CustomRouterLink = forwardRef(function CustomRouterLink(props, ref) {
  return <RouterLink ref={ref} {...props} />;
});

const SidebarNav = ({ pages, ...rest }) => {
  return (
    <List {...rest} sx={{ p: 0 }}>
      {pages.map(page => {
        const isDisabled = !page.path || page.path === '#';

        return (
          <ListItem
            key={page.label}
            disableGutters
            sx={{
              py: 0.5
            }}>
            <Button
              component={isDisabled ? 'button' : CustomRouterLink}
              disabled={isDisabled}
              to={isDisabled ? undefined : page.path}
              onClick={isDisabled ? event => event.preventDefault() : undefined}
              sx={{
                width: '100%',
                justifyContent: 'flex-start',
                textTransform: 'none',
                borderRadius: '8px',
                px: 1.5,
                py: 1.2,
                color: '#9B6A2F',
                bgcolor: 'transparent',
                fontWeight: 500,
                boxShadow: 'none',

                '& svg': {
                  fontSize: 22
                },

                '&:hover': {
                  bgcolor: '#ECD3AC6F',
                  color: '#9B6A2F',
                  boxShadow: 'none'
                },

                '&.active': {
                  bgcolor: '#ECD3AC6F',
                  color: '#9B6A2F',
                  fontWeight: 600
                },

                '&.Mui-disabled': {
                  color: '#B8A794',
                  opacity: 0.65,
                  cursor: 'not-allowed',
                  pointerEvents: 'auto',
                  bgcolor: 'transparent'
                }
              }}>
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mr: 1
                }}>
                {page.icon}
              </Box>

              {page.label}
            </Button>
          </ListItem>
        );
      })}
    </List>
  );
};

SidebarNav.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      label: PropTypes.string.isRequired,
      path: PropTypes.string
    })
  ).isRequired
};

export default SidebarNav;